import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import './fonts/wotfard/wotfard-medium-webfont.ttf';
import './fonts/wotfard/wotfard-regular-webfont.ttf';
import './fonts/wotfard/wotfard-light-webfont.ttf';
import './fonts/wotfard/wotfard-semibold-webfont.ttf';
import './fonts/wotfard/wotfard-bold-webfont.ttf';
import './fonts/based/Based-Regular.22ef1e41.woff2';
import { AppWithRouter } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Catch `/`, `/about`, `/about&projects`, etc. (SPA rewrite on Firebase) */}
        <Route path="*" element={<AppWithRouter />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
